import { useState } from 'react';

import { ModalBase } from '../../../components/modals/ModalBase';

import type React from 'react';

export interface ApproveWithNoteModalProps {
  open: boolean;
  typeLabel: string;
  /** Tipo 7 / Tipo 8 podem cair em dupla aprovação — mostra o aviso. */
  dualApproval: boolean;
  isPending: boolean;
  failed: boolean;
  outcome: string | null;
  onClose: () => void;
  onConfirm: (approvalNote: string | undefined) => void;
}

export function ApproveWithNoteModal({
  open,
  typeLabel,
  dualApproval,
  isPending,
  failed,
  outcome,
  onClose,
  onConfirm,
}: ApproveWithNoteModalProps): React.JSX.Element | null {
  const [note, setNote] = useState('');
  if (!open) return null;

  const trimmed = note.trim();

  return (
    <ModalBase
      open={open}
      onClose={onClose}
      title={dualApproval ? 'Enviar para aprovação dupla' : 'Aprovar override'}
      width={500}
      footer={
        <div style={{ display: 'flex', gap: 8, marginLeft: 'auto' }}>
          <button className="btn-ghost-mini" type="button" onClick={onClose} disabled={isPending}>
            Cancelar
          </button>
          <button
            className="btn-ghost-mini btn-ghost-mini--primary"
            type="button"
            disabled={isPending}
            onClick={() => onConfirm(trimmed === '' ? undefined : trimmed)}
          >
            {isPending ? 'Aprovando…' : dualApproval ? 'Enviar p/ gestor' : 'Aprovar'}
          </button>
        </div>
      }
    >
      <div className="modal-form">
        <p>
          Aprovar o override <b>{typeLabel}</b>?
        </p>
        {dualApproval && (
          <div
            className="modal-form__callout modal-form__callout--warn"
            style={{ fontSize: 'var(--text-xs)' }}
          >
            ⚠ Esta aprovação exige uma 2ª aprovação do gestor (chain pos 3+).
          </div>
        )}
        <label className="modal-form__field">
          <span className="modal-form__label">Nota de aprovação (opcional)</span>
          <textarea
            className="modal-form__textarea"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            rows={2}
            placeholder="Contexto adicional para o registro de auditoria…"
          />
        </label>
        {failed && (
          <div className="banner banner--danger" role="alert">
            <div className="banner__body">
              <span className="banner__title">Não foi possível aprovar o override.</span>
            </div>
          </div>
        )}
        {outcome !== null && (
          <div className="modal-form__callout" role="status">
            {outcome}
          </div>
        )}
      </div>
    </ModalBase>
  );
}
